module.exports = __webpack_public_path__ + "media/images/map/setting-icon-9efa37a7ddf41e54826cc27ea61b0fe5.svg";